module.exports = __webpack_public_path__ + "media/images/logo-1bf0569610f5050e3b86851ab9f33056.png";